import { useMemo } from 'react';

// @ts-ignore - no types for ar-style-base
import { ThemeLoader } from '@nextroll/ar-style-base';

import { BU_ADROLL, BU_ROLLWORKS, SupportedBUs } from '../constants';
import ThemeWrapperContext, {
    buildThemeWrapperContext,
} from '../contexts/ThemeWrapperContext';

const STATIC_PATH = process.env.STATIC_PATH;

const ThemeWrapper = ({ children }: { children: React.ReactChild }) => {
    const product = new URLSearchParams(window.location.search).get('product');
    const businessUnit: SupportedBUs =
        product === 'b2b' ? BU_ROLLWORKS : BU_ADROLL;

    /**
     * Construct necessary context values for ThemeWrapperContext.
     */
    const themeValues = useMemo(
        () => buildThemeWrapperContext(businessUnit),
        [businessUnit]
    );

    return (
        <ThemeWrapperContext.Provider value={themeValues}>
            <ThemeLoader
                advertisable={{
                    business_unit: businessUnit,
                    is_b2b: product === 'b2b',
                }}
                staticPath={STATIC_PATH}
                disableRollWorksTheme
            >
                {children}
            </ThemeLoader>
        </ThemeWrapperContext.Provider>
    );
};

export default ThemeWrapper;
